module.exports = __webpack_public_path__ + "img/idcard1.558ee167.png";